// HeaderLogged.js


import './styles.css';
import React, { useState, useEffect } from 'react';
import imagem from './images/logotipo.svg';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function collapseSidebar() {
  let sidebar = document.getElementById("sidebar");
  let content = document.getElementById("divContent");
  let divSidebar = document.getElementById("divSidebar");

  if(sidebar && content && divSidebar) {
    sidebar.classList.toggle("show");
    divSidebar.classList.toggle("collapsedSidebarMargin");
    content.classList.toggle("collapsedContentMargin");
  }
}

// Fecha a sidebar caso o usuario mude a proporçao
function closeSideBar() {
  let divContent = document.getElementById("divContent");
  let divSidebar = document.getElementById("divSidebar")

  if(divSidebar && divContent) {
    divSidebar.classList.remove("collapsedSidebarMargin");
    divContent.classList.remove("collapsedContentMargin");
  }

  logoPosition();
}

// Posiciona a logo AIDATACAPTURE a direita no modo para mobile
function logoPosition() {
  let screenWidth = window.innerWidth;

  let aiDataCaptureLogo = document.getElementById("aiDataCaptureLogo");

  let isSmallScreen = screenWidth < 992;

  if(aiDataCaptureLogo) {
    aiDataCaptureLogo.classList.toggle("justify-content-center", !isSmallScreen);
    aiDataCaptureLogo.classList.toggle("justify-content-end", isSmallScreen);
  }
}

  window.addEventListener("resize", closeSideBar);
  window.addEventListener("load", closeSideBar);

const HeaderLogged = ({ header }) => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser));
    }
  }, []);

  const companyID = currentUser && currentUser.companyID ? currentUser.companyID : 'defaultID';
  const imageUrl = "https://aidatacapturedata.blob.core.windows.net/imagens/" + companyID + ".png";

  function handleImageError(event) {
    event.target.src = "https://aidatacapturedata.blob.core.windows.net/imagens/default.png";
  }

  return (
    <nav className="navbar navbar-expand-lg fixed-top shadow" style={{backgroundColor: "#052213"}}>
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Link className="navbar-brand d-none d-lg-inline" to="/controlpanel">
          <img src={imagem} alt="Logo" style={{width: "100px"}} />
        </Link>
        
        <button className="navbar-toggler btn text-white" type="button" onClick={collapseSidebar} data-target="#target">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
          </svg>
        </button>

        <div className="flex-grow-1 d-flex justify-content-center" id='aiDataCaptureLogo'>
          <Link to="/controlpanel" className="navbar-brand text-center">
            <h1>
              <span className="logoverde">AI</span>
              <span className="logobranco">DATACAPTURE</span>
              <span className="logoverde">7</span>
            </h1>
          </Link>
        </div>

        <div className='navbar-nav justify-content-end d-none d-lg-inline'>
          <div className="dropdown position-static">
            <a href="#" className="d-flex align-items-center text-decoration-none dropdown-toggle nav-link fs-5 ms-3 text-white" data-bs-toggle="dropdown" aria-expanded="false">
            <img src={imageUrl} height="50" width="50" onError={handleImageError}></img>
              <strong className="fs-5 ms-3">{currentUser && currentUser.Login}</strong>
            </a>
            <ul className="dropdown-menu dropdown-menu-end text-small shadow dropdown-menu-test">
              {/* <li><a className="dropdown-item" href="#">...</a></li> */}
              {/* <li><hr className="dropdown-divider"/></li> */}
              <li><Link className="dropdown-item" to="/" reloadDocument>Sair</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default HeaderLogged;

